import { GetServerSideProps } from "next";
import { ReactElement } from "react";

import { getPageProps } from "@services/initial-calls";
import WorkersCompensationRatesWrapper from "@components/layouts/workersCompensationRatesWrapper";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";

export default function FreeCreditEvaluationHome(): ReactElement {
    return (
        <WorkersCompensationRatesWrapper>
            <TermsAndConditions
                domain="WorkersCompensationRates.com"
                category="Workers Compensation"
            />
        </WorkersCompensationRatesWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
